'use client'

import React from 'react'
import Image from 'next/image'
import AnimatedSection from '@/components/AnimatedSection'
import Typography from '@/components/Typography'
import styles from './styles.module.css'

const Main: React.FC = () => {
	return (
		<section className={styles.section}>
			<AnimatedSection animation='slideUp'>
				<div className={styles.content}>
					<Typography variant='h1' className={styles.title}>
						Аутстаффинг IT‑специалистов
					</Typography>
					<Typography variant='p1' color='description' className={styles.description}>
						Предоставляем выделенных специалистов или целые команды. Это позволяет быстро расти и закрывать кадровые потребности без затрат на долгий поиск и найм.
					</Typography>
				</div>
			</AnimatedSection>
			<AnimatedSection animation='slideUp'>
				<div className={styles.imageContainer}>
					<Image
						src='/images/outstaffing/main_desktop.svg'
						alt='Аутстаффинг'
						width={1110}
						height={500}
						className={styles.desktopImage}
						unoptimized
					/>
					<Image
						src='/images/outstaffing/main_tablet.svg'
						alt='Аутстаффинг'
						width={680}
						height={500}
						className={styles.tabletImage}
						unoptimized
					/>
					<Image
						src='/images/outstaffing/main_mobile.svg'
						alt='Аутстаффинг'
						width={328}
						height={300}
						className={styles.mobileImage}
						unoptimized
					/>
				</div>
			</AnimatedSection>
		</section>
	)
}

Main.displayName = 'Main'

export default Main
